 <section id="donation-list">

        <div class="container">
            <div class="text-center">
                <h1>Waste to Best Coming Soon</h1>
            </div>
        </div>
    </section>

    <!-- donation section ends -->

    
    <div class="clearfix"></div>